import LexicalTextEditor from "@/components/inputs/TextEditor/LexicalTextEditor";
import * as WidgetComps from './comps/WidgetComps/_EXPORTS'
import { optionDef } from "./comps/WidgetComps/DataVizWidgetGeneratorV2";
import { toArray } from "oolib";


export const TOTAL_COLUMNS = 12;
export const GRID_GAP = 8;

export const componentsMap = {
  ...Object.keys(WidgetComps)
    .reduce((acc, key) => {
      const {Component} = WidgetComps[key];
      return ({
        ...acc,
        ...({[key]: Component} || {})
      })
    },{})
}

export const allWidgetsBaseConfs = [
  ...Object.values(WidgetComps).flatMap(({optionDef}) => toArray(optionDef)), //this way optionDef could be an array as well as a object. (array helps when a single comp like WidgetGenerator handles multiple chart types)
];


export const defaultWidgetConfigs = {
  ...Object.keys(WidgetComps)
    .reduce((acc, key) => {
      const {defaultConfig} = WidgetComps[key];
      return ({
        ...acc,
        ...({[key]: defaultConfig} || {})
      })
    },{})
};

export const widgetMetaConfigs = {
  ...Object.keys(WidgetComps)
    .reduce((acc, key) => {
      const {metaConfig} = WidgetComps[key];
      return ({
        ...acc,
        ...({[key]: metaConfig} || {})
      })
    },{})
};

export const processRawConfig = {
  ...Object.keys(WidgetComps)
    .reduce((acc, key) => {
      const {processRawConfigFn} = WidgetComps[key];
      return ({
        ...acc,
        ...({[key]: processRawConfigFn} || {})
      })
    },{})
}




export const sampleConfig = [
  {
    id: 1,
    gridColumn: "1/ 13",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["main.issueCategory"],

      style: { height: "100%" },
    },
  },
  {
    id: 2,
    gridColumn: "1/ 4",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["main.partner"],

      style: { height: "100%" },
    },
  },
  {
    id: 3,
    gridColumn: "4/ 7",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["tags.reason"],
    },
  },
  {
    id: 4,
    gridColumn: "7/ 10",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["tags.reason"],
    },
  },
  {
    id: 5,
    gridColumn: "10/ 13",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["tags.reason"],
    },
  },
  {
    id: 6,
    gridColumn: "1/ 13",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["main.issueCategory"],
    },
  },
  {
    id: 7,
    gridColumn: "1/ 5",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["main.partner"],
    },
  },
  {
    id: 8,
    gridColumn: "5/ 9",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["tags.reason"],
    },
  },
  {
    id: 9,
    gridColumn: "9/ 13",
    comp: "DataVizWidgetGeneratorV2",
    props: {
      contentType: "safetyConcernData",

      dimensions: ["tags.reason"],
    },
  },
]
